module.exports = __webpack_public_path__ + "static/img/logo.faa39bbc.png";